// esto solo se usa en transferencias gRPC, mantener separado
export interface IQueryFiltroPlain {
    tags?: string;
    excludedTags?: string;
    subdominio: string;
    opinion?: boolean;
    directo?: boolean;
    tipologia?: string;
    destacadas?: boolean;
    redactor?: string;
    usuario?: string;
    noId?: string;
    publicada?: boolean;
    titulo?: string;
    fecha_inicio?: string;
    fecha_fin?: string;
    portadilla?: string;
    uniqueRedactor?: boolean;
}
export interface ITagKey {
    subdominio: string,
    url: string,
}

export interface ILimitedTagKey {
    key: ITagKey,
    limit: number,
}

export interface IQueryFiltro {
    tags?: ITagKey[][];
    excludedTags?: ITagKey[][];
    limitedTags?: ILimitedTagKey[];
    subdominio: string;
    opinion?: boolean;
    directo?: boolean;
    tipologia?: string;
    destacadas?: boolean;
    redactor?: number[];
    usuario?: number[];
    noId?: number[];
    publicada?: boolean;
    titulo?: string;
    fecha_inicio?: string;
    fecha_fin?: string;
    portadilla?: string;
    uniqueRedactor?: boolean;
}
export class QueryFiltro implements IQueryFiltro {
    /* STATIC */
    public static fromPlain(data: IQueryFiltroPlain): QueryFiltro {
        return new this({
            tags: data.tags!=undefined?JSON.parse(data.tags):undefined,
            excludedTags: data.excludedTags!=undefined?JSON.parse(data.excludedTags):undefined,
            subdominio: data.subdominio,
            opinion: data.opinion,
            destacadas: data.destacadas,
            redactor: data.redactor!=undefined?JSON.parse(data.redactor):undefined,
            usuario: data.usuario!=undefined?JSON.parse(data.usuario):undefined,
            noId: data.noId!=undefined?JSON.parse(data.noId):undefined,
            publicada: data.publicada,
            titulo: data.titulo,
            fecha_inicio: data.fecha_inicio,
            fecha_fin: data.fecha_fin,
            portadilla: data.portadilla,
            uniqueRedactor: data.uniqueRedactor,
        });
    }

    public static build(data: IQueryFiltro): QueryFiltro {
        return new this({
            tags: data.tags,
            excludedTags: data.excludedTags,
            subdominio: data.subdominio,
            opinion: data.opinion,
            directo: data.directo,
            tipologia: data.tipologia,
            destacadas: data.destacadas,
            redactor: data.redactor,
            usuario: data.usuario,
            noId: data.noId,
            publicada: data.publicada,
            titulo: data.titulo,
            fecha_inicio: data.fecha_inicio,
            fecha_fin: data.fecha_fin,
            portadilla: data.portadilla,
            uniqueRedactor: data.uniqueRedactor,

        });
    }

    /* INSTANCE */
    public get tags(): ITagKey[][]|undefined    { return this.data.tags; }
    public get excludedTags(): ITagKey[][]|undefined    { return this.data.excludedTags; }
    public get limitedTags(): ILimitedTagKey[]|undefined    { return this.data.limitedTags; }
    public get subdominio(): string             { return this.data.subdominio; }
    public get opinion(): boolean|undefined    { return this.data.opinion; }
    public get directo(): boolean|undefined    { return this.data.directo; }
    public get tipologia(): string|undefined    { return this.data.tipologia; }
    public get destacadas(): boolean|undefined { return this.data.destacadas; }
    public get redactor(): number[]|undefined  { return this.data.redactor; }
    public get usuario(): number[]|undefined   { return this.data.usuario; }
    public get noId(): number[]|undefined       { return this.data.noId; }
    public get publicada(): boolean|undefined  { return this.data.publicada; }
    public get titulo(): string|undefined      { return this.data.titulo; }
    public get fecha_inicio(): string|undefined      { return this.data.fecha_inicio; }
    public get fecha_fin(): string|undefined      { return this.data.fecha_fin; }
    public get portadilla(): string|undefined       { return this.data.portadilla; }
    public get uniqueRedactor(): boolean|undefined             { return this.data.uniqueRedactor; }


    public set tags(tags: ITagKey[][]|undefined)     { this.data.tags = tags; }
    public set limitedTags(limitedTags: ILimitedTagKey[]|undefined)     { this.data.limitedTags = limitedTags; }

    protected constructor(private readonly data: IQueryFiltro) {
    }

    public toJSON(): IQueryFiltro {
        return {
            tags: this.data.tags,
            excludedTags: this.data.excludedTags,
            subdominio: this.data.subdominio,
            opinion: this.data.opinion,
            directo: this.data.directo,
            tipologia: this.data.tipologia,
            destacadas: this.data.destacadas,
            redactor: this.data.redactor,
            usuario: this.data.usuario,
            noId: this.data.noId,
            publicada: this.data.publicada,
            titulo: this.data.titulo,
            fecha_inicio: this.data.fecha_inicio,
            fecha_fin: this.data.fecha_fin,
            portadilla: this.data.portadilla,
            uniqueRedactor: this.data.uniqueRedactor,
        };
    }

    public toPlain(): IQueryFiltroPlain {
        return {
            tags: this.data.tags!=undefined&&this.data.tags.length>0?JSON.stringify(this.data.tags):undefined,
            excludedTags: this.data.excludedTags!=undefined&&this.data.excludedTags.length>0?JSON.stringify(this.data.excludedTags):undefined,
            subdominio: this.data.subdominio,
            opinion: this.data.opinion,
            directo: this.data.directo,
            tipologia: this.data.tipologia,
            destacadas: this.data.destacadas,
            redactor: this.data.redactor!=undefined&&this.data.redactor.length>0?JSON.stringify(this.data.redactor):undefined,
            usuario: this.data.usuario!=undefined&&this.data.usuario.length>0?JSON.stringify(this.data.usuario):undefined,
            noId: this.data.noId!=undefined&&this.data.noId.length>0?JSON.stringify(this.data.noId):undefined,
            publicada: this.data.publicada,
            titulo: this.data.titulo,
            fecha_inicio: this.data.fecha_inicio,
            fecha_fin: this.data.fecha_fin,
            portadilla: this.data.portadilla,
            uniqueRedactor: this.data.uniqueRedactor,
        };
    }
}

interface IQueryPlain {
    filtro: IQueryFiltroPlain;
}
export interface IQuery {
    filtro: IQueryFiltro;
}
interface IQueryClase {
    filtro: QueryFiltro;
}
export class Query implements IQuery {
    /* STATIC */
    public static fromPlain(data: IQueryPlain): Query {
        return new this({
            filtro: QueryFiltro.fromPlain(data.filtro),
        });
    }

    public static build(data: IQuery): Query {
        return new this({
            filtro: QueryFiltro.build(data.filtro),
        });
    }

    /* INSTANCE */
    public get filtro(): QueryFiltro { return this.data.filtro; }

    public constructor(private readonly data: IQueryClase) {
    }

    public toJSON(): IQuery {
        return {
            filtro: this.data.filtro.toJSON(),
        }
    }

    public toPlain(): IQueryPlain {
        return {
            filtro: this.data.filtro.toPlain(),
        };
    }
}
